import { jsx as _jsx } from "react/jsx-runtime";
import { HttpStatus } from '@ciceksepeti/cs-http-status';
import IconCiceksepeti from '@components/icon-ciceksepeti/icon-ciceksepeti';
import { useResponsive } from '@hooks/use-responsive';
import '@ciceksepeti/cs-http-status/styles.css';
import '@ciceksepeti/cs-button/styles.css';
import styles from './styles.module.scss';
var ServerError = function () {
    var isMobileDevice = useResponsive().isMobileDevice;
    return (_jsx(HttpStatus, { isMobile: isMobileDevice, className: styles.status500, code: "500", title: "\u00DCzg\u00FCn\u00FCz! Sistemsel bir hata olu\u015Ftu.", subTitle: "Durumu d\u00FCzeltmek i\u00E7in \u00E7al\u0131\u015F\u0131yoruz. K\u0131sa bir s\u00FCre sonra tekrar deneyiniz.", buttonProps: {
            children: 'Anasayfaya Git',
            startIcon: _jsx(IconCiceksepeti, {})
        } }));
};
export default ServerError;
